import { StatePricingResponse } from "../models/StatePricingResponse";
import { PricingStateResponse } from "../models/PricingStateResponse";
import http from "../http/http-config";

export default new class statePricingService {
    getStatePricing(applicationId, policyID, pricingId, statePricing): Promise<StatePricingResponse> {
        return http.get<StatePricingResponse>("StatePricing", {
            params: {
                applicationId,
                policyID,
                pricingId,
                statePricing
            }
        }).then(response => response.data)
    }

    getPricingState(): Promise<PricingStateResponse> {
        return http.get<PricingStateResponse>("StatePricing/GetPricingState").then(response => response.data)
    }
}